import wrapWithProvider from './src/wrapWithProvider';
// gatsby-browser.js

export const onInitialClientRender = () => {
  const theme = process.env.GATSBY_THEME || 'light';
  document.documentElement.setAttribute('data-theme', theme);
};

export const wrapRootElement = wrapWithProvider;
